module.exports = __webpack_public_path__ + "img/Car@2x.c3132da2.png";